import React, { ReactElement } from 'react';
import Block from '../../Layout/Block';
import DescriptionImage from '../../Layout/DescriptionImage/DescriptionImage';
import '../../Layout/Main.scss';
import '../home.scss';
import TrackableLink from '../../TrackableLink';

const NeubaukarteInfo = (): ReactElement => (
  <div style={{ paddingBottom: '2rem' }}>
    <div className="bigH1">Neubau-Karte</div>
    <div className="spacer" />

    <div className="p-grid">
      <div className="lg:col-6">
        <h2>Alle Neubauprojekte in Wien auf einer Karte</h2>
        <h3>Darstellung aktueller Neubauprojekte</h3>
        <Block>
          Die benutzerfreundliche, kartenbasierte Suche nach Neubauprojekten in
          Wien ist nun endlich verfügbar. Dadurch können Sie noch schneller
          einen Überblick verschaffen, wo in Wien Neubauprojekte errichtet
          werden.
          <br />
          <TrackableLink to="/neubau-karte/" className="inlineLink">
            {'>'} Weiter zur Neubau-Karte
          </TrackableLink>
        </Block>

        <h3>Lage im Bezirk oder Grätzel</h3>
        <Block>
          Die Lage gilt als wichtiges Kriterium beim Kauf einer Wohnung. Über
          die Neubau-Karte können Sie die Suche auf bestimmte Bezirke oder
          Grätzel einschränken.
        </Block>

        <h3>Öffentliche Verkehrsanbindung</h3>
        <Block>
          Die Nachfragen nach Neubau-Wohnungen in Wien steigt, je besser das
          Neubauprojekt an den öffentlichen Verkehr angebunden ist. In der
          Neubau-Karte wird die öffentliche Anbindung durch das Verkehrsnetz der
          Ubahnen und Straßenbahnen dargestellt.
        </Block>
      </div>
      <div className="lg:col-6 imageCol">
        <DescriptionImage
          link="/neubau-karte"
          linkTitle="Neubau-Karte"
          linkAriaLabel="Neubauprojekte nach Lage suchen"
          src="/home/neubau-karte-neubauprojekte-wien.png"
          alt="neubau-karte-neubauprojekte-wien"
          descriptionTitle="Neubauprojekte nach Lage suchen"
          description="Suchen Sie nach Neubauprojekten in bestimmten Grätzeln? Unsere Neubau-Karte für Wien macht dies möglich!"
          tintColor="#537a57"
          textColor="#ffffff"
        />
      </div>
    </div>
  </div>
);

export default NeubaukarteInfo;
